import React from 'react';
import { ProductLinePanierVariantView } from './ProductLinePanierVariant.view';
import { sanitizeCalculToString } from '../../../../helpers/number/sanitizeCalul';
import { CommandeLinePanier } from '../../../../types/commandeLine/commandeLine.def';
import { toast } from 'react-hot-toast';

interface ProductLinePanierVariantProps {
  line: CommandeLinePanier;
  onClickViewMore: () => void;
  onClickTrash: () => void;
  updateCartAction: (productId: string, quantity: number) => void;
}

export const ProductLinePanierVariant = ({
  line,
  onClickViewMore,
  onClickTrash,
  updateCartAction
}: ProductLinePanierVariantProps) => {
  const updateCartArticleQuantity = (newQtd: number) => {
    updateCartAction(line.produit.id, newQtd);
    toast.success(`Quantité de ${line.produit.name} mis à jour 🔌`);
  };

  return (
    <ProductLinePanierVariantView
      line={line}
      price={sanitizeCalculToString(line.totalLine)}
      onClickViewMore={onClickViewMore}
      onClickTrash={onClickTrash}
      updateCartQuantity={updateCartArticleQuantity}
    />
  );
};
